import type { ReactNode } from 'react';

import { Up2RentLogoWithTextIcon } from '@ui/components/icons';
import { Div } from '@ui/components/layout/Div';
import { Typography, TypographyVariant } from '@ui/components/texts/Typography';
import { cn } from '@ui/lib/utils';

const LOGO_CLASSES = 'mt-7.5 mb-5 h-17.5 w-auto -translate-x-1 pb-1.25';

interface AuthLayoutProps {
  children: ReactNode;
  banner?: ReactNode;
  footer?: ReactNode;
  className?: string;
}

const AuthLayout = ({ children, banner, footer, className }: AuthLayoutProps) => (
  <Div column className={cn('w-full items-center', className)}>
    {banner}
    <Up2RentLogoWithTextIcon className={LOGO_CLASSES} role="img" aria-label="Up2Rent" />
    {children}
    {footer && (
      <Typography variant={TypographyVariant.MUTED} size="xs" className="pt-4">
        {footer}
      </Typography>
    )}
  </Div>
);

export { AuthLayout };
export type { AuthLayoutProps };
